module.exports = __webpack_public_path__ + "static/img/icon42.fb0e058.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon42.png
// module id = B4Q2
// module chunks = 0